import React from 'react';
import {List as BaseList} from 'react-admin';

const Index = (props) => {
  return (<BaseList {...props} />)
};

export default Index;
